import { gql } from "@apollo/client";

export const GET_SERVICE_POINT = gql`
  query GetServicePoint($id: ID!) {
    servicePoint: getServicePoint(id: $id) {
      _id
      code
      qrCode
      propertyCode
      customerCode
      accountCode
      meterCode
      serviceType
      serviceClass
      geoCode
      meterLocation
      transformerNumber
      contractedDemand
      status
      subStatus
      customerRepresentative {
        title
        fullName
        phoneNumber
        emailAddress
        profileImageUrl
        ghanaCardNumber
        identityCardNumber
        identityCardType
        nationality
        hasGhanaCard
        identityCardBackImageUrl
        identityCardExpiryDate
        identityCardFrontImageUrl
        identityCardIssueDate
        ghanaCardBackImageUrl
        ghanaCardExpiryDate
        ghanaCardFrontImageUrl
        ghanaCardIssueDate
        gender
        dateOfBirth
        extraEmailAddresses
        extraPhoneNumbers
      }
      customerOrganization {
        name
        organizationRegistrationNumber
        organizationRegistrationDate
        organizationRegistrationDocumentUrl
        taxIdentificationNumber
      }
      customerType
      customerCode
      meta {
        lastReadingDate
        lastBillDate
        lastReadingValue
      }
      tariffClass {
        name
        _id
        serviceClass
      }
      property {
        regionName
        districtName
        blockName
        roundName
        plotCode
        code
        _id
        ghanaPostAddress
        streetName
        structureNumber
        closestLandmark
        address
        owner {
          fullName
          phoneNumber
        }
        premiseType {
          code
          name
        }
        premiseCategory {
          code
          name
        }
        sitePlanDocumentUrl
        geoLocation {
          coordinates
          type
        }
      }
      customerType
      meter {
        code
        model {
          name
          code
        }
        brand {
          code
          name
        }
        modelType
        modelMeta {
          phase
        }
      }
      structureNumber
      activity {
        name
      }
      subActivity {
        name
      }
      cartesianLocation {
        easting
        northing
      }
      energyCertificateDocumentUrl
      energyCertificateNumber
      district {
        _id
      }
      address
      payer {
        fullName
        primaryPhoneNumber
        primaryEmailAddress
        phoneNumbers
        emailAddresses
      }
      block {
        _id
      }
      blockCode
      blockName
      district {
        _id
      }
      districtCode
      districtName
      plot {
        _id
        code
        name
      }
      plotName
      plotCode
      region {
        _id
      }
      regionName
      regionCode
      poleNumber
      round {
        _id
      }
      roundCode
      roundName
      extraAttributes {
        _id
        name
        value
      }
    }
  }
`;


export const GET_BILL = gql`
  query GetBill($id: ID!) {
    bill: getBill(id: $id) {
      _id
      code
      servicePoint {
        _id
      }
      servicePointCode
      customerCode
      accountCode
      meterCode
      physicalMeterCode
      serviceType
      serviceClass
      geoCode
      servicePointStatus
      customerRepresentative {
        title
        fullName
        phoneNumber
        emailAddress
        profileImageUrl
        ghanaCardNumber
        identityCardNumber
        identityCardType
        nationality
        hasGhanaCard
        identityCardBackImageUrl
        identityCardExpiryDate
        identityCardFrontImageUrl
        identityCardIssueDate
        ghanaCardBackImageUrl
        ghanaCardExpiryDate
        ghanaCardFrontImageUrl
        ghanaCardIssueDate
        gender
        dateOfBirth
        extraEmailAddresses
        extraPhoneNumbers
      }
      customerOrganization {
        name
        organizationRegistrationNumber
        organizationRegistrationDate
        organizationRegistrationDocumentUrl
        taxIdentificationNumber
      }
      customerType
      customerCode
      tariffClassCode
      tariffClassName
      customerType
      meter {
        code
        model {
          name
          code
        }
        brand {
          code
          name
        }
        modelType
        modelMeta {
          phase
        }
      }
      activity {
        name
      }
      subActivity {
        name
      }
      district {
        _id
      }
      address
      payer {
        fullName
        primaryPhoneNumber
        primaryEmailAddress
        phoneNumbers
        emailAddresses
      }
      block {
        _id
      }
      blockCode
      blockName
      district {
        _id
      }
      districtCode
      districtName
      plot {
        _id
        code
        name
      }
      physicalMeterCode
      plotName
      plotCode
      region {
        _id
      }
      regionName
      regionCode
      round {
        _id
      }
      roundCode
      roundName
      extraAttributes {
        _id
        name
        value
      }
      mda {
        _id
        code
        name
      }
      ministry {
        _id
        code
        name
      }
      billingCycle {
        _id
        code
        name
        category
      }

      year
      month

      consumptionValue
      consumptionStartValue
      consumptionEndValue
      consumptionPeriod
      consumptionStartDate
      consumptionEndDate
      consumptionExportValue
      consumptionExportStartValue
      consumptionExportEndValue
      consumptionApparentValue
      consumptionApparentStartValue
      consumptionApparentEndValue
      consumptionMaxDemandEndValue

      billDate
      billPeriod
      billStartDate
      billEndDate
      billAvgConsumptionValue
      billConsumptionValue
      billAmount
      importAmount
      exportAmount
      extraAmount
      netAmount
      bills {
        currentDate
        previousDate
        numberOfDays
        consumption
        billItems {
          title
          displayTitle
          unit
          quantity
          unitCost
          cost
        }
        billAmount
      }
      importBills {
        currentDate
        previousDate
        numberOfDays
        consumption
        billItems {
          title
          displayTitle
          unit
          quantity
          unitCost
          cost
        }
        billAmount
      }
      exportBills {
        currentDate
        previousDate
        numberOfDays
        consumption
        billItems {
          title
          displayTitle
          unit
          quantity
          unitCost
          cost
        }
        billAmount
      }
      extraBills {
        currentDate
        previousDate
        numberOfDays
        consumption
        billItems {
          title
          displayTitle
          unit
          quantity
          unitCost
          cost
        }
        billAmount
      }
      adjustments {
        currentDate
        previousDate
        numberOfDays
        consumption
        billItems {
          title
          displayTitle
          unit
          quantity
          unitCost
          cost
        }
        billAmount
      }

      adjustmentAmount

      outstandingAmount
      outstandingNetAmount

      payments {
        _id
        code
        date
        amount
        reference
        status
      }
      paymentsAmount
      previousPayments {
        _id
        code
        date
        amount
        reference
        status
      }

      consumptionHistory {
        month
        value
        exportValue
      }
      consumptionHistoryMax
      downloadUrl

      amountDue
      netAmountDue
      netCycle
      amountDueAt
      meta
    }
  }
`;

export const GET_SERVICE_POINT_TRANSACTIONS = gql`
  query GetServicePointTransactions(
    $servicePoint: ID
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    transactions: getTransactions(
      servicePoint: $servicePoint
      fromDate: $fromDate
      toDate: $toDate
      dateField: "processedAt"
      sort: "processedAt"
      page: 0
      pageSize: 0
    ) {
      _id
      code
      amount
      type
      itemType
      balanceBefore
      balanceAfter
      processedAt
      itemDescription
      itemReference
    }
  }
`;